/* Events — share button.
   Shares the event's name, date, location, details and URL. The Web Share
   API takes the name as `title` and the rest as `text`; the clipboard
   fallback gets the same information as one plain-text block, since a bare
   URL loses everything the share sheet would have shown.
   Add-to-calendar is a per-event Google Calendar link built in
   snippets/event-card.liquid — no JS needed. */

(function () {
  if (window.__eventsShareBound) return;
  window.__eventsShareBound = true;

  /* "Load more". Upcoming reveals every remaining event at once. Past pages
     through them `past_load_more_count` at a time — the block cap was lifted,
     so one click could otherwise drop dozens of rows into the page — and once
     everything is out the button turns into Show less. The first
     `past_initial_count` rows are shown by the section's CSS, so the page
     paints right without this; the button only ever tags rows past that.
     This used to be a hidden checkbox + label, so clicking it moved focus
     onto the checkbox; on some mobile browsers that focus jump scrolled the
     page down as the newly revealed rows expanded the panel underneath it.
     A real button has no focus target to jump to. */
  document.addEventListener('click', function (event) {
    const btn = event.target.closest('[data-events-toggle]');
    if (!btn) return;

    const panel = btn.closest('.events__panel--upcoming, .events__panel--past');
    if (!panel) return;

    if (btn.dataset.eventsToggle !== 'past') {
      const expanded = panel.classList.toggle('is-expanded');
      btn.setAttribute('aria-expanded', String(expanded));
      return;
    }

    const items = panel.querySelectorAll('.events__past-item');
    const initial = Number(panel.dataset.pastInitial) || 0;
    const step = Number(panel.dataset.pastStep) || items.length;
    const shown = Number(panel.dataset.pastShown) || initial;
    const all = panel.classList.contains('is-expanded');

    const next = all ? initial : Math.min(shown + step, items.length);
    items.forEach(function (item, i) {
      item.classList.toggle('is-revealed', i < next);
    });
    panel.dataset.pastShown = String(next);

    const expanded = next >= items.length;
    panel.classList.toggle('is-expanded', expanded);
    btn.setAttribute('aria-expanded', String(expanded));

    const count = panel.querySelector('[data-past-count]');
    if (count) count.textContent = count.dataset.pastCount.replace('%d', next);
  });

  const RESET_MS = 2000;

  /* Liquid has no newline literal, so event-card.liquid passes the parts as
     separate attributes and they are joined here, one per line. Blank parts
     drop out, so an event with no description loses that line rather than
     leaving a gap. */
  function joinParts(parts) {
    return parts
      .filter(function (part) {
        return part && part.trim() !== '';
      })
      .join('\n');
  }

  document.addEventListener('click', async function (event) {
    const btn = event.target.closest('[data-event-share]');
    if (!btn) return;
    event.preventDefault();

    const d = btn.dataset;
    const title = d.shareTitle || document.title;
    const url = d.shareUrl || window.location.href;

    /* Fixed order and wording asked for by the client:
         Join Me at BIATCH Tequila's Event:
         <title>
         <date>
         <location>
         <description>
         Learn More: <url>
       The link is labelled rather than left bare, so it reads as the CTA. */
    const cta = d.shareCta ? d.shareCta + ' ' + url : url;
    const full = joinParts([d.shareIntro, title, d.shareDate, d.shareLocation, d.shareDetails, cta]);

    /* No `url` field. The link already sits in the text as the "Learn More:"
       line, and a target given both appends the url to the message, which
       printed the same link twice. */
    if (navigator.share) {
      try {
        await navigator.share({ title, text: full });
        return;
      } catch (_) {
        // user dismissed or share failed — fall through to clipboard
      }
    }

    try {
      await navigator.clipboard.writeText(full);
      btn.dataset.copied = 'true';
      setTimeout(function () {
        delete btn.dataset.copied;
      }, RESET_MS);
    } catch (_) {
      window.prompt('Copy event details:', full);
    }
  });

  /* Past-event galleries. The rail is a CSS scroll-snap strip, so swiping and
     the smooth scroll are the browser's job; this only maps dot clicks onto
     the rail and reflects the scrolled position back onto the dots. Both
     handlers are delegated from the document, so any number of rows on any
     number of sections work with no per-element setup and nothing to rebind
     when the theme editor re-renders a section. */

  var syncQueued = false;

  function syncDots(rail) {
    var slider = rail.parentElement;
    var dots = slider ? slider.querySelectorAll('[data-event-dot]') : [];
    if (!dots.length || !rail.clientWidth) return;

    var current = Math.round(rail.scrollLeft / rail.clientWidth);
    for (var i = 0; i < dots.length; i++) {
      if (i === current) dots[i].setAttribute('aria-current', 'true');
      else dots[i].removeAttribute('aria-current');
    }
  }

  document.addEventListener('click', function (event) {
    var dot = event.target.closest('[data-event-dot]');
    if (!dot) return;

    var slider = dot.closest('[data-event-slider]');
    var rail = slider && slider.querySelector('[data-event-rail]');
    if (!rail) return;

    rail.scrollLeft = rail.clientWidth * Number(dot.dataset.eventDot);
    syncDots(rail);
  });

  // Scroll doesn't bubble, so listen in the capture phase.
  document.addEventListener(
    'scroll',
    function (event) {
      var rail = event.target;
      if (!rail || rail.nodeType !== 1 || !('eventRail' in rail.dataset)) return;
      if (syncQueued) return;

      syncQueued = true;
      window.requestAnimationFrame(function () {
        syncQueued = false;
        syncDots(rail);
      });
    },
    true
  );
})();
